<template>
  <div class="department-list-page">
    <header class="page-header">
      <div class="container">
        <div class="breadcrumb-section">
          <h2 class="current-category-title">科室导航</h2>
        </div>
      </div>
    </header>

    <div class="container">
      <aside class="sidebar">
        <div class="sidebar-section">
          <ul class="category-list">
            <li v-for="(dept, index) in departments" :key="dept.id" class="tree-item">
              <div class="tree-row">
                <span class="expand-icon empty"></span>
                <a href="#" @click.prevent="selectDepartment(index, dept)" 
                   :class="{ active: activeTab === index }">
                  {{ dept.name }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </aside>

      <main class="main-layout">
        <div class="department-content" v-if="currentDepartment">
          <h2 class="dept-title">{{ currentDepartment.name }}</h2>
          <img v-if="getDepartmentImageByArticleId(currentDepartment.id)" :src="getDepartmentImageByArticleId(currentDepartment.id)" :alt="currentDepartment.name" class="dept-full-image" />
          <div v-else class="no-image-tip">该科室图片待上传</div>
        </div>
        <div v-else class="loading-state">
          加载中...
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

const preloadedImages = {}
const requireContext = require.context('@/assets/images/keshi', false, /\.jpg|\.png$/)
requireContext.keys().forEach(key => {
  const fileName = key.replace('./', '')
  const match = fileName.match(/p(\d+)\.(jpg|png)$/)
  if (match) {
    preloadedImages[match[1]] = requireContext(key)
  }
})
console.log('🖼️ 预加载的所有keshi图片映射:', preloadedImages)

export default {
  name: 'DepartmentList',
  data() {
    return {
      activeTab: 0,
      departments: [],
      currentDepartment: null,
      flatCategories: [],
      departmentCategoryId: null,
      deptFirstArticleMap: {}
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.fetchCategories()
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await axios.get('/api/categories')
        console.log('=== 后端返回的全部分类数据 ===', response.data)
        if (response.data && response.data.flat) {
          this.flatCategories = response.data.flat
          console.log('🔍 打印所有分类的id和parent_id:')
          for (var idx = 0; idx < this.flatCategories.length; idx++) {
            var item = this.flatCategories[idx]
            console.log('  分类' + (idx+1) + ' → id:', item.id, ', parent_id:', item.parent_id, ', name:', item.name)
          }
          var deptCat = null
          for (var i = 0; i < this.flatCategories.length; i++) {
            if (this.flatCategories[i].name === '科室介绍') {
              deptCat = this.flatCategories[i]
              break
            }
          }
          console.log('✅ 科室介绍栏目的完整对象:', deptCat)
          console.log('✅ 科室介绍栏目的id:', deptCat ? deptCat.id : '未找到')
          if (deptCat) {
            this.departmentCategoryId = deptCat.id
            this.departments = []
            for (var j = 0; j < this.flatCategories.length; j++) {
              if (this.flatCategories[j].parent === deptCat.id) {
                this.departments.push(this.flatCategories[j])
              }
            }
            console.log('📋 科室介绍的所有子栏目列表：', this.departments)
            for (var k = 0; k < this.departments.length; k++) {
              console.log('  子栏目' + (k + 1) + ' → id:', this.departments[k].id, ', 名称:', this.departments[k].name)
            }
          }
          if (this.departments.length > 0) {
            var targetDeptName = this.$route.query.dept
            var foundIndex = -1
            if (targetDeptName) {
              for (var findIdx = 0; findIdx < this.departments.length; findIdx++) {
                if (this.departments[findIdx].name === targetDeptName) {
                  foundIndex = findIdx
                  break
                }
              }
            }
            var selectIdx = foundIndex >= 0 ? foundIndex : 0
            this.selectDepartment(selectIdx, this.departments[selectIdx])
            this.fetchAllDeptFirstArticles()
          }
        }
      } catch (error) {
        console.error('获取分类失败:', error)
      }
    },
    selectDepartment(index, dept) {
      this.activeTab = index
      this.currentDepartment = dept
    },
    getDepartmentImageByArticleId(deptId) {
      var articleId = this.deptFirstArticleMap[deptId]
      if (!articleId) {
        console.warn('科室id' + deptId + ' 没有对应的第一篇文章id')
        return ''
      }
      var imgSrc = preloadedImages[articleId.toString()]
      if (imgSrc) {
        console.log('✅ 找到图片 p' + articleId + '.jpg 对应科室「' + (this.currentDepartment ? this.currentDepartment.name : '') + '」')
        return imgSrc
      } else {
        console.warn('❌ 图片 p' + articleId + '.jpg 不存在')
        return ''
      }
    },
    async fetchAllDeptFirstArticles() {
      console.log('🚀 调用后端接口批量获取科室子栏目第一篇文章...')
      try {
        var response = await axios.get('/api/department-first-articles')
        this.deptFirstArticleMap = response.data.data || {}
        console.log('✅ 后端返回的科室第一篇文章id映射:', this.deptFirstArticleMap)
        for (var key in this.deptFirstArticleMap) {
          console.log('  科室id ' + key + ' → 第一篇文章id: ' + this.deptFirstArticleMap[key])
        }
        if (this.currentDepartment) {
          var tempCurrent = this.currentDepartment
          this.currentDepartment = null
          this.$nextTick(function() {
            this.currentDepartment = tempCurrent
          })
        }
      } catch (err) {
        console.error('调用接口失败:', err)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.department-list-page {
  min-height: 100vh;
  background: #f5f5f5;
}

.page-header {
  position: sticky;
  top: 198px;
  z-index: 150;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 20px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .breadcrumb-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .breadcrumb {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666;

    a {
      color: #4ecdc4;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    span {
      margin: 0 8px;
      color: #999;
    }
  }

  .current-category-title {
    font-size: 36px;
    font-weight: bold;
    color: #4ecdc4;
    margin: 0;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
  display: flex;
  gap: 30px;
}

.sidebar {
  width: 300px;
  flex-shrink: 0;
  position: sticky;
  top: 175px;
  align-self: flex-start;
}

.sidebar-section {
  background: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.category-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li.tree-item {
    border-bottom: 1px dashed #eee;

    &:last-child {
      border-bottom: none;
    }

    .tree-row {
      display: flex;
      align-items: center;
      padding: 6px 0;

      .expand-icon {
        cursor: pointer;
        font-size: 8px;
        width: 12px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 6px;
        color: #4ecdc4;

        &.empty {
          cursor: default;
          color: transparent;
        }
      }

      a {
        flex: 1;
        font-size: 14px;
        color: #666;
        text-decoration: none;

        &:hover, &.active {
          color: #4ecdc4;
          font-weight: bold;
        }
      }
    }
  }
}

.main-layout {
  flex: 1;
}

.loading-state {
  text-align: center;
  padding: 80px 0;
  color: #999;
  font-size: 16px;
}

.department-content {
  flex: 1;
  background: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.dept-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.no-image-tip {
  text-align: center;
  padding: 60px 0;
  color: #999;
  font-size: 16px;
}

.dept-full-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 5px;
}
</style>
